<template>
  <div class="fields">
    <template v-if="tableItems.length">
      <div class="fields__search">
        <BaseInput
          v-model="searchValue"
          placeholder="Поиск по всем параметрам"
          isSearch
          @enter="onSearch"
        />
      </div>

      <AppTable
        :fields="tableFields"
        :items="tableItems"
        @sort="onSortTable"
      >
        <template #title="{ id, title }">
          <BaseLink :href="'/fields/' + id">
            <span>{{ title }}</span>
          </BaseLink>
        </template>

        <template #fieldStatus="{ fieldStatus }">
          <span :style="getColor(fieldStatus.value)">
            {{ fieldStatus.label }}
          </span>
        </template>
      </AppTable>

      <div
        v-if="(paginationTotal / paginationPerPage) > 1"
        class="fields__pagination-wrapper"
      >
        <AppPagination
          v-model="paginationCurrent"
          :totalRows="paginationTotal"
          :perPage="paginationPerPage"
          class="fields__pagination"
        />
      </div>
    </template>

    <p v-else class="h3">Список площадок пуст.</p>
  </div>
</template>

<script>
import BaseInput from '@/components/Base/BaseInput'
import AppTable from '@/components/AppTable'
import AppPagination from '@/components/Base/AppPagination'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'AppList',
  components: {
    BaseInput,
    AppTable,
    AppPagination,
    BaseLink
  },
  data () {
    return {
      tableItems: [],
      searchValue: '',
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 10,
      order: 'DESC',
      sort: 'id'
    }
  },
  computed: {
    /**
     * Тело запроса
     */
    fetchFieldsRequestBody () {
      console.log()

      return {
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent,
        searchBy: this.searchValue,
        sort: this.sort,
        order: this.order
      }
    },
    tableFields () {
      const roles = this.$store.getters['auth/loggedInUser'].role
      let role = 'ROLE_MANAGER'

      if (roles.includes('ROLE_ADMIN')) {
        role = 'ROLE_ADMIN'
      }

      const fields = {
        title: { key: 'title', label: 'Название', sortable: true, slot: true },
        address: { key: 'address', label: 'Адрес', sortable: true },
        coating: { key: 'coating', label: 'Покрытие', sortable: true },
        fieldStatus: { key: 'fieldStatus', label: 'Статус', slot: true },
        userStatus: { key: 'userStatus', label: 'Статус пользователя' },
        price: { key: 'price', label: 'Стоимость', sortable: true },
        rating: { key: 'rating', label: 'Рейтинг', sortable: true }
      }

      if (role === 'ROLE_ADMIN') {
        return [
          fields.title,
          fields.address,
          fields.coating,
          fields.userStatus,
          fields.price,
          fields.rating
        ]
      } else {
        return [
          fields.title,
          fields.address,
          fields.coating,
          fields.fieldStatus,
          fields.price,
          fields.rating
        ]
      }
    }
  },
  watch: {
    /** Отслеживанию изменение св-ва и подтягиваю новые данные таблицы */
    paginationCurrent: 'fetchFields'
  },
  async created () {
    await this.fetchFields()
  },
  methods: {
    getColor (val) {
      if (val === 'ready') {
        return { color: '#72FE88' }
      } else if (val === 'deleted') {
        return { color: '#FF3939' }
      }

      return null
    },
    async fetchFields () {
      try {
        const { data } = await this.$api.field.list(this.fetchFieldsRequestBody)
        /* Записал общее колво пользователей */
        this.paginationTotal = data.pages * this.paginationPerPage
        const items = data?.list ?? []

        this.tableItems = items.map(item => {
          const userStatus = item?.userStatus ?? []
          const roles = userStatus.map(i => i?.label)

          return {
            id: item.id,
            title: item.title,
            address: item.address,
            coating: item.coating,
            fieldStatus: item?.status,
            userStatus: roles.join(', '),
            price: item.price,
            rating: item.rating
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * Записал новое значение поиска
     */
    async onSearch () {
      await this.fetchFields()
    },
    /**
     * Записал новые значения сортировки
     */
    onSortTable (event) {
      this.sort = event.key
      this.order = event.by.toUpperCase()
      this.fetchFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.fields {
  &__search {
    width: 650px;
    margin-bottom: 20px;
  }

  &__pagination-wrapper {
    text-align: right;
    margin-top: 20px;
  }
}
</style>
